module.exports = __webpack_public_path__ + "static/media/dside-receipt.b51fafad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyPages/Forge/dside-receipt.svg
// module id = 1056
// module chunks = 0